import { PRICE_STATES } from "./Prices.constants";

const initialState = {
  status: PRICE_STATES.idle,
  prices: [],
  loadingDirection: "down",
  downLimit: false,
  upLimit: false,
  page: null,
  pageSize: null,
  total: null,
};

const Prices = (
  state = initialState,
  action: {
    type: string;
    prices: [];
    direction: string;
    page: number;
    pageSize: number;
    total: number;
    error: any;
  }
) => {
  switch (action.type) {
    case "GET_PRICES":
      return {
        ...state,
        status: PRICE_STATES.loading,
        prices: action.direction === "navigate" ? [] : state.prices,
        loadingDirection: action.direction,
      };
    case "GET_PRICES_SUCCESS": {
      return {
        prices: action.prices,
        loadingDirection: action.direction,
        downLimit:
          action.direction === "down" && action.total < action.pageSize
            ? true
            : false,
        upLimit:
          action.direction === "up" && action.total < action.pageSize
            ? true
            : false,
        page: action.page,
        pageSize: action.pageSize,
        total: action.total,
        status: PRICE_STATES.success,
      };
    }
    case "GET_PRICES_FAILURE":
      return {
        ...initialState,
        status: PRICE_STATES.failure,
      };
    default:
      return state;
  }
};

export default Prices;
